module.exports = __webpack_public_path__ + "img/example-person.caac35dd.jpg";